export default __webpack_public_path__ + "static/media/CNo.90-1.5daae7b5.jpg";